import { jsx as _jsx } from "react/jsx-runtime";
import { useOgPricing, useUpdateOgPricing } from '@/api/opengater/usePricing';
import { ConfigFormScreen } from './ConfigFormScreen';
/**
 * Тарифы — users service `admin: pricing-settings`. Single row: read + update.
 * The bonus amounts from the same row are edited on «Бонусы». Editing is
 * admin-only; the server is the real gate, the UI lock is UX.
 */
export function OpengaterPricing() {
    const q = useOgPricing();
    const upd = useUpdateOgPricing();
    return (_jsx(ConfigFormScreen, { title: "\u0422\u0430\u0440\u0438\u0444\u044B", subtitle: "\u0426\u0435\u043D\u044B \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0438", capability: "pricing.write", sections: [
            {
                title: 'Цены',
                fields: [
                    {
                        key: 'base_price',
                        label: 'Базовая цена',
                        kind: 'money',
                        suffix: '₽',
                        hint: 'Базовая стоимость подписки за месяц.',
                    },
                    {
                        key: 'device_price',
                        label: 'Цена за устройство',
                        kind: 'money',
                        suffix: '₽',
                        hint: 'Доплата за каждое устройство сверх базового числа.',
                    },
                    {
                        key: 'base_device_number',
                        label: 'Базовое число устройств',
                        kind: 'int',
                        min: 0,
                        hint: 'Сколько устройств входит в базовую цену.',
                    },
                ],
            },
        ], data: q.data, isLoading: q.isLoading, error: q.error, warnings: q.data?.warnings, saving: upd.isPending, saveError: upd.error, saved: upd.isSuccess, onSave: (patch) => upd.mutate(patch), onResetFeedback: upd.reset }));
}
